module.exports = __webpack_public_path__ + "img/noticia-6.3080feb9.jpg";